import React from 'react';
import { Route, Switch } from 'react-router-dom';
import CampaignResult from '../components/campaign_result/index';
import Startup from './Startup';

export function SharedCampaignResultLoader({
  results,
  campaign,
  campaignResultIdentifier,
  ...props
}) {
  return (
    <Startup {...props}>
      <Switch>
        <Route
          path="*/results/:identifier"
          render={(props) => (
            <CampaignResult
              campaign={campaign}
              results={results}
              campaignResultIdentifier={campaignResultIdentifier}
              {...props}
            />
          )}
        />
      </Switch>
    </Startup>
  );
}

export default SharedCampaignResultLoader;
